import axiosPrivateMl from "@services/axiosPrivateMl"
import { SYNC_AND_PROCESS_CREATIVE_FOLDER, GET_FOLDER_SYNC_AND_PROCESS_STATUS, GET_MULTIPLE_STATUS } from "../../constants"

export const syncAndProcessFolder = (data) => {
  return axiosPrivateMl.post(SYNC_AND_PROCESS_CREATIVE_FOLDER, data)
}

export const getFolderSyncAndProcessStatus = (jobId) => {
  return axiosPrivateMl.get(`${GET_FOLDER_SYNC_AND_PROCESS_STATUS}/${jobId}`)
}

export const getMultipleJobsStatus = (jobIds) => {
  return axiosPrivateMl.post(GET_MULTIPLE_STATUS, { job_ids: jobIds })
}